<template>
  <prototype-attribute-table attribute-name="fabric" />
</template>

<script>
import PrototypeAttributeTable from '../components/PrototypeAttributeTable.vue'

export default {
  components: {
    PrototypeAttributeTable
  }
}
</script>

<style scoped>
</style>
